import { render, staticRenderFns } from "./sch_shixi.vue?vue&type=template&id=4117aeb0&scoped=true"
import script from "./sch_shixi.vue?vue&type=script&lang=js"
export * from "./sch_shixi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4117aeb0",
  null
  
)

export default component.exports